module.exports = __webpack_public_path__ + "static/img/03.516f85f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/03.jpg
// module id = 1ntO
// module chunks = 0